import { Component, input } from '@angular/core';

export type EmptyStateVariant = 'dashed' | 'solid' | 'transparent';

@Component({
  selector: 'cui-empty-state',
  standalone: true,
  host: {
    class: 'cui-empty-state-host',
  },
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.css',
})
export class EmptyStateComponent {
  description = input<string | null>(null);
  icon = input<string | null>(null);
  title = input.required<string>();
  variant = input<EmptyStateVariant>('dashed');
}
